import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { ActivatedRoute, RouterLink } from '@angular/router'
import { catchError, Observable, of, Subscription, switchMap, tap } from 'rxjs'
import {
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { NgIf, DatePipe, NgFor } from '@angular/common'
import { Title } from '@angular/platform-browser'
import { TrackingFormComponent } from '../tracking-form/tracking-form.component'
import { NgxPaginationModule } from 'ngx-pagination'
import { Pagination } from '../../../models/pagination.interface'
import { TrackingService } from '../../../services/tracking/tracking.service'
import { IncidentService } from '../../../services/incident/incident.service'
import { MatNativeDateModule } from '@angular/material/core'
import { Tracking } from '../../../models/tracking.interface'
import { ToastrService } from 'ngx-toastr'
import { Incident } from '../../../models/incident.interface'
import { UploadfileService } from '../../../services/uploadfile/uploadfile.service'
import { OnlysuperuserDirective } from '../../../directives/onlysuperuser.directive'

@Component({
    selector: 'app-tracking-list',
    templateUrl: './tracking-list.component.html',
    styleUrls: ['./tracking-list.component.css'],
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        MatIcon,
        RouterLink,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        NgxPaginationModule,
        MatNativeDateModule,
        DatePipe,
        OnlysuperuserDirective,
    ],
})
export class TrackingListComponent implements OnInit, OnDestroy {
    public page: number | undefined
    @Input() filtro: string = ''
    @Input() orden: string = ''
    incident: string | null = null
    incidenteSeleccionado: Incident | null = null
    tracking: Tracking | null = null
    limit = 10
    total = 0
    asyncTracking!: Observable<Pagination<Tracking[]>>
    trackingList: Tracking[] = []
    pagination: Pagination<any> | null = null

    showColumns: string[] = [
        'acciones',
        'date',
        'affectationKind',
        'affectationScope',
        'affectationDetail',
        'commitments',
        'supportKind',
        'supportDetail',
        'remainingSupport',
        'file',
    ]

    displayedColumns: string[] = [
        'id',
        'violenceType',
        'conflictRelated',
        'phisicAgression',
        'description',
        'witnesses',
        'location',
        'perpetror',
        'victim',
    ]

    private routeSubscription: Subscription | undefined

    constructor(
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private title: Title,
        private trackingService: TrackingService,
        private incidentService: IncidentService,
        private toastr: ToastrService,
        private uploadfileService: UploadfileService
    ) {
        this.title.setTitle('Seguimientos')
    }

    ngOnInit(): void {
        this.fetchTracking()
    }
    ngOnDestroy(): void {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe()
        }
    }

    fetchTracking() {
        this.route.paramMap
            .pipe(
                switchMap((params) => {
                    const id = params.get('id')
                    if (id) {
                        this.incident = id
                        return this.incidentService.getById(id)
                    }
                    return []
                })
            )
            .subscribe((incident) => {
                this.trackingList = incident.trackings
                this.incidentService.setIncident(incident)
                this.incidenteSeleccionado = incident
                this.trackingList = incident.trackings
            })
    }

    createTracking() {
        this.trackingService.removeSelectedTracking()
        const dialogRef = this.dialog.open(TrackingFormComponent, {
            width: '90vw',
            maxWidth: '95vw',
            maxHeight: '90vh',
            panelClass: 'custom-dialog-container',
            data: {
                isCreate: true,
                incidentId: this.incident,
            },
        })
        dialogRef.afterClosed().subscribe(() => {
            this.fetchTracking()
        })
    }

    editTracking(tracking: Tracking) {
        this.trackingService.setSelectedTracking(tracking)

        const dialogRef = this.dialog.open(TrackingFormComponent, {
            width: '90vw',
            maxWidth: '80vw',
            maxHeight: '80vh',
            panelClass: 'custom-dialog-container',
            data: {
                isCreate: false,
            },
        })

        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
                this.fetchTracking()
            }
        })
    }

    deleteTracking(trackingId: number) {
        if (confirm('¿Seguro que deseas eliminar este seguimiento?')) {
            this.trackingService
                .deleteTracking(trackingId)
                .pipe(
                    tap(() => {
                        const successMsg = `Eliminado CORRECTAMENTE!`
                        this.toastr.success(successMsg, 'Exitoso!', {
                            progressBar: true,
                            timeOut: 5000,
                        })
                        this.fetchTracking()
                    }),
                    catchError((err) => {
                        console.error('Error eliminando seguimiento:', err)
                        const successMsg = `NO se pudo eliminar!`
                        this.toastr.error(successMsg, 'Error!', {
                            progressBar: true,
                            timeOut: 5000,
                        })
                        return of(null)
                    })
                )
                .subscribe()
        }
    }

    openFile(incident: Incident): void {
        const id = incident?.fileAttach?.fileUrl
        const name = incident?.fileAttach?.fileName || 'archivo'
        this.uploadfileService.openPdfById(id, name).subscribe({
            error: () => {
                const msg = `No se pudo descargar o previsualizar el archivo`
                this.toastr.error(msg, 'Error', {
                    progressBar: true,
                    timeOut: 5000,
                })
            },
        })
    }

    hasFile(incident: Incident) {
        return (
            !!incident?.fileAttach?.fileUrl && !!incident?.fileAttach?.fileName
        )
    }
}
